module.exports = __webpack_public_path__ + "media/images/flags/nz-06845d78bff43b6440c9371aea7c0173.svg";